<!--Close button for R13.-->
<div *ngIf="isR13" class="close-button" (click)="navigateToDefaultRoute($event)">
	<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 113">
		<path
			fill="#9868E2"
			fill-rule="evenodd"
			d="M39.121 43.293l10.606 10.606 10.608-10.606c.39-.39 1.023-.39 1.414 0l1.414 1.414c.39.39.39 1.024 0 1.414L52.556 56.727l10.607 10.608c.39.39.39 1.023 0 1.414l-1.414 1.414c-.39.39-1.024.39-1.414 0L49.727 59.556 39.121 70.163c-.39.39-1.023.39-1.414 0l-1.414-1.414c-.39-.39-.39-1.024 0-1.414l10.606-10.608-10.606-10.606c-.39-.39-.39-1.023 0-1.414l1.414-1.414c.39-.39 1.024-.39 1.414 0z"
		/>
	</svg>
</div>

<!--Back button for R10.-->
<div *ngIf="isR10" (click)="navigateToDefaultRoute($event)">
	<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
		<path fill="#FBA102" fill-rule="evenodd" d="M6 11.657l1.414-1.414-4.242-4.244 4.242-4.242L6 .343.343 6 6 11.657z" />
	</svg>
	Back to Home
</div>
